import script from "./accountDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./accountDetail.vue?vue&type=script&setup=true&lang=js"

import "./accountDetail.vue?vue&type=style&index=0&id=8ce26a30&lang=less"

const __exports__ = script;

export default __exports__